/**
  * @prop --header-logo-primary-height: height of the primary logo
  * @prop --header-logo-primary-mobile-height: height of the primary logo on mobile
  * @prop --header-logo-secondary-height: height of the secondary logo
  * @prop --header-logo-secondary-mobile-height: height of the secondary logo on mobile
 */

:host {
  display: block;

  sd-header::part(main) {
    max-width: 1200px;

    --sd-header-padding: 16px 16px 0 16px;

    @media (min-width: 768px) {
      --sd-header-padding: 24px 24px 0 24px;
    }

    @media (min-width: 1200px) {
      --sd-header-padding: 24px 0 0 0;
    }
  }

  background-color: $sd-backgroundColor-white;
  z-index: $z-index-header;
  position: relative;

  .top,
  .bottom {
    display: flex;
    justify-content: space-between;

    &__left,
    &__right {
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }
  }

  .top {
    padding-bottom: 16px;

    @include breakpoint($desktop) {
      padding-bottom: 0;
      margin-bottom: 10px;
    }

    &__left {
      display: flex;
      gap: 32px;
      flex-shrink: 1;

      @include breakpoint($desktop) {
        flex-shrink: 0;
      }

      .divider {
        height: 100%;
        width: 1px;
        background-color: #ccc;
      }
    }

    &__right {
      gap: 32px;
    }
  }

  .bottom {
    display: none;

    @include breakpoint($desktop) {
      display: flex;
      align-items: flex-end;
      margin-top: 16px;
    }

    &__left {
      .navigation--desktop {
        margin-left: -16px;
      }
    }

    &__right {
      .service-area {
        margin-right: -16px;
      }
    }
  }

  .primary-logo,
  .secondary-logo {
    img {
      display: block;
      max-width: 100%;
    }

    // Hide desktop logo only if no mobile-logo
    img:nth-of-type(1):not(:last-of-type) {
      display: none;
    }

    @include breakpoint($desktop) {
      // Show desktop logo on desktop
      img:nth-of-type(1):not(:last-of-type) {
        display: unset;
      }

      // Hide mobile logo on desktop
      img:nth-of-type(2) {
        display: none;
      }
    }
  }

  .primary-logo {
    img:nth-of-type(1) {
      height: var(--header-logo-primary-height, 52px);
    }

    img:nth-of-type(2) {
      height: var(--header-logo-primary-mobile-height, 52px);
    }
  }

  .secondary-logo {
    img:nth-of-type(1) {
      height: var(--header-logo-secondary-height, 52px);
    }

    img:nth-of-type(2) {
      height: var(--header-logo-secondary-mobile-height, 52px);
    }
  }

  .navigation-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &--row {
      flex-direction: row;
      align-items: flex-end;

      .primary-logo {
        margin-right: 25px;
        align-items: flex-end;
      }
    }
  }

  .navigation--desktop {
    display: none;
  }

  .service-area {
    display: none;
  }

  .off-canvas-toggle {
    text-decoration: none;
    font-size: 0;
    background-color: transparent;
    border: none;
    cursor: pointer;

    &::before {
      /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
      font-family: UI-IconFont;
      content: '\e62b';
      line-height: 1;
      font-weight: normal;
      -webkit-font-smoothing: antialiased;
      overflow: hidden;
      font-size: 42px;
      color: var(--skin-color-primary, $sd-textColor-primary-DEFAULT);
    }
  }

  .offcanvas-trigger {
    font-size: 0;
    height: 42px;
  }

  .search-trigger {
    display: flex;
    align-items: center;
    height: 42px;

    button {
      margin-top: 0.5rem;
      text-decoration: none;
      font-size: 0;
      background-color: transparent;
      border: none;
      cursor: pointer;
    }
  }

  /*** 768 ***/
  @include breakpoint($desktop) {
    .navigation--desktop {
      display: block;
    }

    .service-area-wrapper {
      &--flipped {
        flex-direction: row-reverse;
        align-items: center;
        bottom: unset;
        top: 0;

        .secondary-logo {
          margin-bottom: 0;
          margin-left: 25px;
        }
      }

      &--centered {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
      }
    }

    .service-area {
      display: block;
      margin-left: 10px;
    }
  }

  .pointer {
    cursor: pointer;
  }
}
